var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgD0065574334F667F8248239845Bbb0F596264296Fd239C5Df7Efc220B5A93792({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.2876 21.0659C7.2128 22.242 8.66625 22.9999 10.3006 22.9999C11.935 22.9999 13.3884 22.242 14.3136 21.0659C11.6497 21.4269 8.95159 21.4269 6.2876 21.0659Z",
    fill: "#424143"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7244 8.7V9.47451C17.7244 10.404 17.9897 11.3127 18.4868 12.086L19.705 13.9813C20.8177 15.7124 19.9683 18.0653 18.033 18.6128C12.9704 20.0447 7.63041 20.0447 2.56779 18.6128C0.632546 18.0653 -0.216907 15.7124 0.895788 13.9813L2.11397 12.086C2.61108 11.3127 2.87635 10.404 2.87635 9.47451V8.7C2.87635 4.44741 6.20021 1 10.3004 1C14.4005 1 17.7244 4.44741 17.7244 8.7Z",
    fill: "#424143"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2998 1C13.7101 1 10.7998 3.91034 10.7998 7.5C10.7998 11.0897 13.7101 14 17.2998 14C20.8895 14 23.7998 11.0897 23.7998 7.5C23.7998 3.91034 20.8895 1 17.2998 1Z",
    fill: "#FF2D2D",
    stroke: "#F5F5F5",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD0065574334F667F8248239845Bbb0F596264296Fd239C5Df7Efc220B5A93792);
export default __webpack_public_path__ + "static/media/d0065574334f667f8248239845bbb0f596264296fd239c5df7efc220b5a93792.a12d9e0063fbb861ea2abedd35ece49e.svg";
export { ForwardRef as ReactComponent };